// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"yY-z","sponsoredTooltipWrapper":"zY-z","sponsoredTooltip":"AY-z","newCard":"BY-z"};